import { toIntlLocale } from '../../i18n/travelFormat';

/** 僅格式化顯示；大額整數使用 BigInt，絕不將帳務真值轉為浮點數或改寫 payload。 */
export function formatExpenseMoney(value,currency,locale){
  const match=/^(-?)(\d+)(?:\.(\d+))?$/.exec(String(value??''));
  if(!match)return '—';
  try{
    const intlLocale=toIntlLocale(locale)||locale;
    const standard=new Intl.NumberFormat(intlLocale,{style:'currency',currency}).resolvedOptions().maximumFractionDigits;
    const scale=Math.max(standard,(match[3]||'').length);
    const number=new Intl.NumberFormat(intlLocale,{style:'currency',currency,minimumFractionDigits:scale,maximumFractionDigits:scale});
    let integer=window.BigInt(match[2]);if(match[1])integer=-integer;
    const negativeZero=match[1]&&integer===0n;
    return number.formatToParts(negativeZero?-1n:integer).map(part=>part.type==='fraction'?(match[3]||'').padEnd(scale,'0'):negativeZero&&part.type==='integer'?'0':part.value).join('');
  }catch(e){return '—';}
}

/** 既有驗證錯誤映射為共用語系文案，不讓使用者看到內部錯誤或翻譯 key。 */
export function expenseValidationText(error,t,tf){
  const raw=String(error?.message||'');
  const aliases={
    '請輸入有效的非負金額':'validAmount',
    '請選擇日期完整的行程日':'validDay',
    '基礎金額必須大於零':'positiveBase'
  };
  const precision=/^此幣別只允許 (\d+) 位有效小數$/.exec(raw);
  if(precision)return tf('travel.expense.s06.precision',{scale:precision[1]});
  if(aliases[raw])return t('travel.expense.s06.'+aliases[raw]);
  if(raw.startsWith('travel.expense.s06.')&&t(raw)!==raw)return t(raw);
  return t('travel.expense.s06.checkAmount');
}
